import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-access-denied',
    template: `
    <div class="error-page">
      <div class="error-page__icon">
        <i class="fa fa-ban"></i>
      </div>
      <h1 class="error-page__code">Access Denied</h1>
      <p class="error-page__message">You do not have permission to access this page.</p>
      <p class="error-page__hint">Please contact your administrator if you believe this is an error.</p>
      <a routerLink="/home" class="error-page__link">Go to Home</a>
    </div>
  `,
    styles: [`
    .error-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 60vh;
      text-align: center;
      padding: 40px;
    }
    .error-page__icon { font-size: 64px; color: #dc3545; margin-bottom: 16px; }
    .error-page__code { font-size: 36px; font-weight: 700; margin: 0; color: #333; }
    .error-page__message { font-size: 20px; color: #555; margin: 8px 0; }
    .error-page__hint { font-size: 14px; color: #888; margin-bottom: 24px; }
    .error-page__link {
      padding: 10px 24px;
      background: #0056b3;
      color: #fff;
      text-decoration: none;
      border-radius: 4px;
    }
    .error-page__link:hover { background: #004094; }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccessDeniedComponent {}
